const comments = [
  {
    name: '影迷小张',
    time: '2小时前',
    rating: 5,
    text: '被窝网电影真的太方便了！不需要注册就能看，资源更新也很快，最近追的几部剧这里都有全集，画质也很清晰，已经推荐给身边的朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20in%20casual%20style%2C%20warm%20lighting%2C%20friendly%20smile%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '追剧达人',
    time: '5小时前',
    rating: 5,
    text: '用了大半年了，播放一直很流畅。特别喜欢热播榜单的功能，每次不知道看什么就去翻榜单，总能发现好片。手机上看也很方便，通勤路上追剧神器。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20natural%20lighting%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '电影发烧友',
    time: '1天前',
    rating: 4,
    text: '资源覆盖面很广，连一些冷门的文艺片都能找到，这点非常惊喜。希望以后能增加更多纪录片和独立电影资源。总体来说体验很棒，五星推荐。',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%2C%20warm%20and%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '周末影迷',
    time: '2天前',
    rating: 5,
    text: '每个周末都在被窝网电影上找片看，动画片专区做得特别好，孩子喜欢的动画电影基本都能找到。没有广告弹窗这点必须点赞，观影体验很纯净。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20gentle%20smile%2C%20warm%20indoor%20lighting%2C%20casual%20home%20style%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            听听影迷们怎么说被窝网电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(c.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-sm text-primary-500"></i>
                ))}
                {[...Array(5 - c.rating)].map((_, j) => (
                  <i key={j} className="ri-star-line text-sm text-foreground-300"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{c.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}